export enum AttributeGroupTypes {
  ProductGeoAttributes = 'PRODUCT_GEO_ATTRIBUTES',
  ProductLabelAttributes = 'PRODUCT_LABEL_ATTRIBUTES',
}

export enum GeoAttributes {
  GeoFaq = 'GEO_FAQ',
  GeoHowTo = 'GEO_HOW_TO',
}
